import { useEffect, useState, useCallback } from 'react';
import { generatePath } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import sessionStorage from 'app/services/session';
import { BEFORE_ROUTE_TRANSITION } from 'app/HOC/withRouteEvents';
import useConfig from 'app/hooks/useConfig';
import useRouter from 'app/hooks/useRouter';
import paymentModule from 'app/store/payment';

const { paymentStatusRequest } = paymentModule.actions;

export default movieCinemaId => {
  const dispatch = useDispatch();
  const order = useSelector(state => state.order);
  const status = useSelector(state => state.payment.status);
  const {
    history: { push }
  } = useRouter();
  const { routes } = useConfig();
  const previousRoute = sessionStorage.getRoute();

  const [isRestrictionModal, setRestrictionModal] = useState(false);
  const yes = useCallback(() => push(previousRoute), [push, previousRoute]);
  const no = useCallback(() => setRestrictionModal(false), []);

  const [isFailModal, setFailModal] = useState(false);

  const retry = useCallback(() => {
    setFailModal(false);
    dispatch(paymentStatusRequest(order.userSessionId));
  }, [order, dispatch]);

  const back = useCallback(() => {
    push(previousRoute);
  }, [push, previousRoute]);

  useEffect(() => {
    if (!status) {
      return undefined;
    }

    if (status.status === status.codes.SUCCESS) {
      push(sessionStorage.getRoute());
    }

    if (status.status === status.codes.FAIL) {
      setFailModal(true);
    }

    const listener = e => {
      const { currentLocation, nextLocation } = e.detail;
      if (
        nextLocation.pathname === generatePath(routes.stepSeats.pattern, { movieCinemaId }) &&
        currentLocation.pathname === generatePath(routes.stepCheckout.pattern, { movieCinemaId })
      ) {
        setRestrictionModal(true);
        push(generatePath(currentLocation.pathname));
      }
    };

    window.addEventListener(BEFORE_ROUTE_TRANSITION, listener, false);

    return () => {
      window.removeEventListener(BEFORE_ROUTE_TRANSITION, listener, false);
    };
    // eslint-disable-next-line
  }, [status, movieCinemaId]);

  return {
    restriction: [isRestrictionModal, yes, no],
    fail: [isFailModal, retry, back]
  };
};
